export const DEVICE_TYPE = {
  MOBILE: 'MOBILE',
  DESKTOP: 'DESKTOP',
};
